/**
 * transforms a url to the current language url
 *
 * @param {String} url - path url starting without language prefix
 */
 export const multilingual_url = (url) => {
  const currentUrlPrefix = window.multilingual_settings.rootUrl;

  if (currentUrlPrefix === '/' || url.startsWith(currentUrlPrefix) || url.startsWith('http')) {
    return url;
  } else {
    return `${currentUrlPrefix}${url}`;
  }
}
